
const _isLocal = /(192\.168|localhost)/.test(location.host)

export default {

  API_PATH : "/front/api",

  LOGIN_PATH  : "/member/login",
  LOGOUT_PATH : "/member/logout",

  AUTH_TOKEN_NAME   : "fronttoken",
  AUTH_TOKENTS_NAME : "fronttokents",

  IS_LOCAL : _isLocal,
}